/* ANGE Projects — Cart drawer redesign behavior
   - Recommendation carousel prev/next arrow scrolling. */
(function () {
  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-carousel-arrow]');
    if (!arrow) return;
    var wrapper = arrow.closest('.cart-drawer__carousel-wrapper');
    var track = wrapper && wrapper.querySelector('[data-carousel-track]');
    if (!track) return;
    var itemWidth = track.clientWidth;
    var direction = arrow.dataset.carouselArrow === 'next' ? 1 : -1;
    track.scrollBy({ left: itemWidth * direction, behavior: 'smooth' });
  });
})();
